import React from "react";
import ConsoleTargetInfo from "../presentational/ConsoleTargetInfo.jsx";
import ConsoleProjectionButtons from "../presentational/ConsoleProjectionButtons.jsx";
import ConsoleLonLatSelects from "../presentational/ConsoleLonLatSelects.jsx";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

/**
 * Main component of the console, which arranges all subcomponents into a grid
 * and passes in target information via props.
 *
 * @component
 */
export default function ConsoleAppBar(props) {

  return (
      <div id="consoleToolbar">
        <div id="lg-bar">
          <ConsoleProjectionButtons />
          <Divider orientation="vertical" />
          <Grid container item direction="column" xs>
            <ConsoleTargetInfo target={props.target} feature={props.feature}/>
            <Grid
              container
              item
              xs
              justifyContent="center"
              alignItems="center"
              wrap="wrap"
            >
              <ConsoleLonLatSelects coordinateSystem={props.coordinateSystem}/>
            </Grid>
          </Grid>
        </div>
        <div id="mini-bar">
          <div>{"– " + props.target.toUpperCase()} {(props.feature == "") ? "" : " – " + props.feature}</div>
          <div>{"– Planeto" + props.coordinateSystem.system + " " + props.coordinateSystem.direction + " " + props.coordinateSystem.range}</div>
        </div>
      </div>
  );
}
